import palette from '../palette';

export default {
  root: {
    margin: '2px',
    color: palette.icon,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};